"use client"

import { Flex, Text, TextProps, BoxProps } from "@chakra-ui/react"
import { useTranslations } from "next-intl"
import React from "react"
import numToPrice from "../lib/numToPrice"

interface IProps {
  value: number
  display?: any
  unstyled?: boolean
  hideCurrency?: boolean
  freeText?: string
  isFreeTextVisible?: boolean
  textProps?: TextProps
  spanProps?: TextProps
  parentProps?: Omit<BoxProps, "direction">
}

const NumberToPrice: React.FC<IProps> = ({
  display,
  value = 0,
  unstyled = false,
  hideCurrency = false,
  freeText,
  isFreeTextVisible = false,
  textProps,
  spanProps,
  parentProps,
}) => {
  const t = useTranslations()

  return (
    <Flex align="center" gap={1} display={display} {...parentProps}>
      {value === 0 && isFreeTextVisible ? (
        <Text {...textProps}>{freeText || t("free")}</Text>
      ) : (
        <>
          <Text {...textProps}>{numToPrice(value)}</Text>
          <Text
            as="span"
            fontWeight={unstyled ? "inherit" : 400}
            {...(spanProps || textProps)}
          >
            {hideCurrency ? "" : "UZS"}
          </Text>
        </>
      )}
    </Flex>
  )
}

export default NumberToPrice
